import { Fragment } from 'react';
import { Trans } from '@lingui/react/macro';
import { Chip, Menu } from '@pocketlaw/tetris';
import { MenuMultiSelectItem } from './MenuMultiSelectItem';
import { SearchMenuEmptyState } from './SearchMenuEmptyState';
import { useSearchableMenu } from './SearchableMenuContext';
import { SearchableMenuErrorState } from './SearchableMenuErrorState';
export function SearchableMenuMultiSelectList(props) {
    const { selected = [], disabledIds = [], renderItem, onSelect, groupBy, emptyComponent, errorComponent, renderListWrapper = true, } = props;
    const { items, searching, error } = useSearchableMenu();
    const selectedItems = (selected || []).map((sId) => items.find((item) => item.id === sId)).filter(Boolean);
    const hasFilteredResult = items.some((item) => !selected.includes(item.id));
    const sortedSelectedItems = selectedItems.sort((a, b) => {
        const aDisabled = disabledIds.includes(a.id);
        const bDisabled = disabledIds.includes(b.id);
        if (aDisabled && !bDisabled) {
            return 1;
        }
        if (!aDisabled && bDisabled) {
            return -1;
        }
        return 0;
    });
    const hasSelectedItems = Boolean(selectedItems.length);
    const displaySelectedItems = selected && hasSelectedItems;
    const listItem = (item, itemSelected) => {
        const isDisabled = disabledIds.includes(item.id);
        const renderItemHelpers = {
            disabled: isDisabled,
        };
        if (renderListWrapper === false) {
            return renderItem(item, renderItemHelpers);
        }
        return (<MenuMultiSelectItem key={item.id} disabled={isDisabled} selected={itemSelected} onClick={() => onSelect === null || onSelect === void 0 ? void 0 : onSelect(item, renderItemHelpers)}>
        {renderItem(item, renderItemHelpers)}
      </MenuMultiSelectItem>);
    };
    const renderItems = () => {
        if (error && errorComponent !== false) {
            return errorComponent || <SearchableMenuErrorState />;
        }
        if (!hasFilteredResult) {
            if (emptyComponent === false) {
                return null;
            }
            return emptyComponent || <SearchMenuEmptyState />;
        }
        if (!groupBy) {
            return (<Fragment>
          <Menu.Label>
            {searching ? (<Trans comment="Searchable menu multiselect list: Subheader when filtered items is visible">
                Filtered items
              </Trans>) : (<Trans comment="Searchable menu multiselect list: Subheader when all items is visible">All items</Trans>)}
          </Menu.Label>
          {items.filter((item) => !selected.includes(item.id)).map((item) => listItem(item))}
        </Fragment>);
        }
        const groups = items
            .filter((item) => !selected.includes(item.id))
            .reduce((acc, item) => {
            const groupByKeyValue = item[groupBy.key];
            acc[groupByKeyValue] = acc[groupByKeyValue] || [];
            acc[groupByKeyValue].push(item);
            return acc;
        }, {});
        return Object.entries(groups).map(([groupKey, groupItems], index, collection) => (<Fragment key={groupKey}>
        <Menu.Label action={<Chip size="small" appearance="secondary" secondary={groupItems.length}/>}>
          {groupBy.getLabel(groupKey)}
        </Menu.Label>
        {groupItems.map((item) => listItem(item))}
        {index < collection.length - 1 && <Menu.Divider />}
      </Fragment>));
    };
    return (<Fragment>
      {displaySelectedItems && (<Fragment>
          <Menu.Label action={<Chip size="small" appearance="secondary" secondary={sortedSelectedItems.length}/>}>
            <Trans comment="Searchable menu multiselect list: Header">Selected</Trans>
          </Menu.Label>

          {sortedSelectedItems.map((item) => listItem(item, true))}

          <Menu.Divider />
        </Fragment>)}

      {renderItems()}
    </Fragment>);
}
